<template>
    <div>
            <v-alert
            text
            prominent
            type="error"
            icon="mdi-cloud-alert"
        >
            {{ alert.text }}
        </v-alert>
    </div>
</template>
<script>
export default {
    props: ["alert"],
}
</script>